export default __webpack_public_path__ + "static/media/wallet_preview.601b34f6.png";